<div class="applied-filters">
  <nb-icon icon="filter" pack="icomoon" class="icon-filter"></nb-icon>
  <p class="bar-title">{{ 'view_translations.applied_filters' | translate }}</p>
  <ng-container *ngFor="let category of Object.keys(appliedFiltersBar)">
    <div class="filter-option" *ngIf="appliedFiltersBar[category].length">
      <span *ngIf="category !== 'acceptance' && category !== 'admin_program_id' && category !== 'program_id'" class="filter-name"
        >{{ ( 'view_translations.' + category | translate ) | titlecase }}</span
      >
      <span *ngIf="category === 'admin_program_id'" class="filter-name">{{ ( 'campaign_id' | t ) | titlecase }}</span>
      <span *ngIf="category === 'program_id'" class="filter-name">{{ ( 'program_id' | t ) | titlecase }}</span>
      <span *ngIf="category === 'acceptance'" class="filter-name">{{ ( 'acceptance_factor' | t ) | titlecase }}</span>
      <div class="value" *ngFor="let option of appliedFiltersBar[category]">
        <span *ngIf="category !== 'countries' && category !== 'admin_program_id' && category !== 'program_id'; else others">
          {{ option.noTranslation ? option.text : ('view_translations.' + option.text | translate )}}
        </span>
        <ng-template #others>
          <ng-container *ngIf="category === 'admin_program_id' || category === 'program_id'">
            <span class="pointer" ngbTooltip="{{ option.name }}" container="body" placement="top-right" tooltipClass="my-configurations-tooltip"
              >{{ option.id }}</span
            >
          </ng-container>
          <ng-container *ngIf="category === 'countries'">
            <span>{{ ('countries.' + (option.countryNumber - 1) | translate).name }}</span>
          </ng-container>
        </ng-template>
        <div class="icon-wrapper" (click)="removeSelectedOption(option, category)">
          <nb-icon icon="basket" pack="icomoon" class="icon"></nb-icon>
        </div>
      </div>
    </div>
  </ng-container>
  <p class="clean" (click)="resetAllFilters()">{{ 'view_translations.clean_filters' | translate }}</p>
</div>
